import { render, staticRenderFns } from "./RobotDetail.vue?vue&type=template&id=0db092e0&scoped=true&"
import script from "./RobotDetail.vue?vue&type=script&lang=js&"
export * from "./RobotDetail.vue?vue&type=script&lang=js&"
import style0 from "./RobotDetail.vue?vue&type=style&index=0&id=0db092e0&scoped=true&lang=css&"
import style1 from "./RobotDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db092e0",
  null
  
)

export default component.exports